import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { ReactComponent as Instagram } from '../images/instagram.svg';
import { ReactComponent as Twitter } from '../images/twitter.svg';

const Contacts = () => (
  <Row>
    <Col sm={6} md={4} className="contacts">
      Avenida Dezessete de Agosto, 312, 1⁰ Andar
      <br />
      Parnamirim | Recife-PE CEP: 52061-250
      <br />
      E-mail: contato@allergocentro.com.br
      <br />
      Telefone: (81) 3071-7590
      <br />
      WhatsApp: (81) 9 9251-7996
      <div>
        <a href="https://twitter.com/AllergoCentro" target="_blank" rel="noopener noreferrer">
          <Twitter height="32px" title="Twitter" />
        </a>{' '}
        <a href="https://instagram.com/allergocentro/" target="_blank" rel="noopener noreferrer">
          <Instagram height="32px" title="Instagram" />
        </a>
      </div>
    </Col>
    <Col sm={6} md={8} className="contacts">
      <div className="contacts_map">
        <iframe
          title="mapa"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3950.649807676679!2d-34.91499582370178!3d-8.034993780230653!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7ab18ce516b25ad%3A0xf2fbeb4c0bcadb1b!2sAllergo%20Centro!5e0!3m2!1sen!2sbr!4v1762115879016!5m2!1sen!2sbr"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowfullscreen
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        />
      </div>
    </Col>
  </Row>
);

export default Contacts;
